// extracted by mini-css-extract-plugin
export var $animation_name = "ShopHeader-module--$animation_name--75c6c";
export var ShopHeader = "ShopHeader-module--ShopHeader--01ff1";
export var ShopHeader__categoryTitle = "ShopHeader-module--ShopHeader__categoryTitle--5fe34";
export var ShopHeader__h1 = "ShopHeader-module--ShopHeader__h1--1cd15";
export var ShopHeader__title = "ShopHeader-module--ShopHeader__title--3a21e";